export default "__VITE_ASSET__d16b09b4__"